import { render } from "./noticeLst.vue?vue&type=template&id=6dd6df45&scoped=true"
import script from "./noticeLst.vue?vue&type=script&lang=js"
export * from "./noticeLst.vue?vue&type=script&lang=js"

import "./noticeLst.vue?vue&type=style&index=0&id=6dd6df45&scoped=true&lang=css"

import exportComponent from "F:\\2021年交接\\前端嘉俊交接\\项目\\新重本紫腾重构\\zbzt-website-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd6df45"]])

export default __exports__